import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import InputMask from 'react-input-mask';
import { Form } from '@servicetitan/design-system';
export const PhoneNumberInput = forwardRef(({ sip, ...props }, ref) => sip ? (_jsx(Form.Input, { ...props, ref: ref })) : (_jsx(InputMask, { maskChar: null, mask: "(999) 999-9999", ...props, children: (() => _jsx(Form.Input, { ref: ref, ...props })) })));
//# sourceMappingURL=phone-number-input.js.map